import { IconButton, Paper, styled } from '@mui/material';

export const SidebarWrapper = styled(Paper)(({ theme }) => ({
  height: '100%',
  padding: 8,
  borderTop: `1px solid ${theme.palette.border.main}`,
  borderRight: `1px solid ${theme.palette.border.main}`,
}));

export const SidebarButton = styled(IconButton)(({ theme }) => ({
  width: '100%',
  flexDirection: 'column',
  padding: 4,
  border: 'none',
  color: theme.palette.text.primary,
}));
